// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EntryDropdown_entry-component-search-box-container__Jbn2Q{
    position: absolute;
    width: 61vw;
    height: 7vw;
    background-color: rgba(255, 255, 255, 0.37);
    margin-left: 19.5vw;
    border-radius: 100vw;
    font-size: 1.2vw;
}

.EntryDropdown_entry-component-search-box__1223G{
    width: 59vw;
    height: 5vw;
    background-color: white;
    border-radius: 100vw;
    align-self: center;
    align-items: center;
    margin: 1vw auto auto;
    cursor: pointer;
    box-sizing: border-box;
    padding-left: 2vw;
    padding-right: 2vw;
    display: flex;
}

.EntryDropdown_entry-dropdown-container__QHQdb{
    position: absolute;
    background: white;
    width: 59vw;
    height: max-content;
    border-radius: 2vw;
    margin-left: 1vw;
    box-sizing: border-box;
    margin-top: 0.3vw;
    overflow: hidden;
}

.EntryDropdown_entry-dropdown-options__gErKX{
    display: flex;
    height: 2.5vw;
    align-items: center;
    padding-left: 2vw;
    margin: 0;
    margin-top: 0;
}

.EntryDropdown_entry-dropdown-options__gErKX:hover{
    background-color: #f5715a;
    color: white;
}


@media(max-width: 768px){
    .EntryDropdown_entry-component-search-box-container__Jbn2Q{
        position: absolute;
        width: 84vw;
        height: 16vw;
        background-color: rgba(255, 255, 255, 0.37);
        margin-left: 8vw;
        border-radius: 100vw;
        font-size: 3vw;
    }

    .EntryDropdown_entry-component-search-box__1223G{
        width: 80vw;
        height: 12vw;
        background-color: white;
        border-radius: 100vw;
        /* align-self: center; */
        margin-top: 2vw;
        margin-left: 2vw;
    }

    .EntryDropdown_entry-dropdown-container__QHQdb{
        position: absolute;
        background: white;
        width: 80vw;
        height: max-content;
        border-radius: 4vw;
        margin-left: 1vw;
        box-sizing: border-box;
        margin-top: 0.3vw;
        overflow: hidden;
    }
    
    .EntryDropdown_entry-dropdown-options__gErKX{
        display: flex;
        height: 7vw;
        align-items: center;
        padding-left: 3vw;
        margin: 0;
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/EntryDropdown/EntryDropdown.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;;AAGA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,2CAA2C;QAC3C,gBAAgB;QAChB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,oBAAoB;QACpB,wBAAwB;QACxB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,iBAAiB;QACjB,SAAS;QACT,aAAa;IACjB;AACJ","sourcesContent":[".entry-component-search-box-container{\n    position: absolute;\n    width: 61vw;\n    height: 7vw;\n    background-color: rgba(255, 255, 255, 0.37);\n    margin-left: 19.5vw;\n    border-radius: 100vw;\n    font-size: 1.2vw;\n}\n\n.entry-component-search-box{\n    width: 59vw;\n    height: 5vw;\n    background-color: white;\n    border-radius: 100vw;\n    align-self: center;\n    align-items: center;\n    margin: 1vw auto auto;\n    cursor: pointer;\n    box-sizing: border-box;\n    padding-left: 2vw;\n    padding-right: 2vw;\n    display: flex;\n}\n\n.entry-dropdown-container{\n    position: absolute;\n    background: white;\n    width: 59vw;\n    height: max-content;\n    border-radius: 2vw;\n    margin-left: 1vw;\n    box-sizing: border-box;\n    margin-top: 0.3vw;\n    overflow: hidden;\n}\n\n.entry-dropdown-options{\n    display: flex;\n    height: 2.5vw;\n    align-items: center;\n    padding-left: 2vw;\n    margin: 0;\n    margin-top: 0;\n}\n\n.entry-dropdown-options:hover{\n    background-color: #f5715a;\n    color: white;\n}\n\n\n@media(max-width: 768px){\n    .entry-component-search-box-container{\n        position: absolute;\n        width: 84vw;\n        height: 16vw;\n        background-color: rgba(255, 255, 255, 0.37);\n        margin-left: 8vw;\n        border-radius: 100vw;\n        font-size: 3vw;\n    }\n\n    .entry-component-search-box{\n        width: 80vw;\n        height: 12vw;\n        background-color: white;\n        border-radius: 100vw;\n        /* align-self: center; */\n        margin-top: 2vw;\n        margin-left: 2vw;\n    }\n\n    .entry-dropdown-container{\n        position: absolute;\n        background: white;\n        width: 80vw;\n        height: max-content;\n        border-radius: 4vw;\n        margin-left: 1vw;\n        box-sizing: border-box;\n        margin-top: 0.3vw;\n        overflow: hidden;\n    }\n    \n    .entry-dropdown-options{\n        display: flex;\n        height: 7vw;\n        align-items: center;\n        padding-left: 3vw;\n        margin: 0;\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component-search-box-container": `EntryDropdown_entry-component-search-box-container__Jbn2Q`,
	"entry-component-search-box": `EntryDropdown_entry-component-search-box__1223G`,
	"entry-dropdown-container": `EntryDropdown_entry-dropdown-container__QHQdb`,
	"entry-dropdown-options": `EntryDropdown_entry-dropdown-options__gErKX`
};
export default ___CSS_LOADER_EXPORT___;
